<div *ngIf="option" class="flex-row gap-10">
    <div class="voteBlock">
        <mat-checkbox #opt1 (change)="setResult.emit(true)" *ngIf="option.nested_multiple_choices"
                      [checked]="option?.nestedResults?.includes(nestedOption.id)"
                      [disableRipple]="true"
                      [disabled]="preview || maxNestedOptionsCheck()"
                      [hidden]="showResult"
                      [value]="nestedOption.id"
                      color="accent">
        </mat-checkbox>
        <mat-radio-button #opt2 (change)="setResult.emit(false)" *ngIf="!option.nested_multiple_choices"
                          [checked]="option?.nestedResults?.includes(nestedOption.id)"
                          [disableRipple]="true"
                          [disabled]="preview"
                          [hidden]="showResult"
                          [name]="'nestedPollOption-' + option.id"
                          [value]="nestedOption.id"
                          color="accent">
        </mat-radio-button>
    </div>
    <ng-content></ng-content>
</div>
